import type { RefObject } from "react";

import { cn } from "@/lib/cn";

import { StepsList, type HelpStep } from "./StepsList";

interface HelpTextHandlerProps {
  botLabel: string;
  partLabel: string;
  title: string;
  steps: HelpStep[];
  heroRef?: RefObject<HTMLElement>;
}

export const HelpTextHandler = ({
  botLabel,
  partLabel,
  title,
  steps,
  heroRef,
}: HelpTextHandlerProps) => (
  <section
    ref={heroRef}
    className="mx-auto w-full"
  >
    {/* Шапка */}
    <div
      className={cn(
        "mb-2 flex w-full flex-col gap-2",
        "px-4 pt-4 pb-6",
        "rounded-mds border border-neutral-200/7 bg-neutral-800/2"
      )}
    >
      <div className="fs-300 mb-2 flex items-center gap-3 font-semibold">
        <span className="text-primary-500">{botLabel}</span>
        <span className="text-neutral-200/61">{partLabel}</span>
      </div>

      <h2 className="fs-500 text-neutral-100 font-semibold sm:fs-700">{title}</h2>
    </div>

    {/* Список шагов */}
    <StepsList
      partLabel={partLabel}
      steps={steps}
    />
  </section>
);
